export default __webpack_public_path__ + "static/media/tv.78c82a7c.svg";